import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { PlusIcon, TrashIcon } from 'lucide-react';
const HealthcarePOA = () => {
  const {
    register
  } = useFormContext();
  const [primaryAttorneys, setPrimaryAttorneys] = useState([{
    id: 1
  }]);
  const [alternateAttorneys, setAlternateAttorneys] = useState([{
    id: 1
  }]);
  const addPrimaryAttorney = () => {
    const newId = primaryAttorneys.length > 0 ? Math.max(...primaryAttorneys.map(a => a.id)) + 1 : 1;
    setPrimaryAttorneys([...primaryAttorneys, {
      id: newId
    }]);
  };
  const removePrimaryAttorney = (id: number) => {
    setPrimaryAttorneys(primaryAttorneys.filter(a => a.id !== id));
  };
  const addAlternateAttorney = () => {
    const newId = alternateAttorneys.length > 0 ? Math.max(...alternateAttorneys.map(a => a.id)) + 1 : 1;
    setAlternateAttorneys([...alternateAttorneys, {
      id: newId
    }]);
  };
  const removeAlternateAttorney = (id: number) => {
    setAlternateAttorneys(alternateAttorneys.filter(a => a.id !== id));
  };
  return <div className="space-y-8" data-id="element-787" data-mp="jbbdauxts65q">
      <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 mb-6" data-id="element-788" data-mp="y2afno82hygv">
        <p className="text-slate-700" data-id="element-789" data-mp="tblne6okcxgo">
          A Power of Attorney for Personal Care gives someone else the legal
          authority to make decisions about your healthcare, housing, and other
          personal matters if you become unable to make these decisions
          yourself.
        </p>
      </div>

      {/* Primary Attorneys */}
      <div className="space-y-4" data-id="element-790" data-mp="1h0ecpkaok72b">
        <div className="flex justify-between items-center" data-id="element-791" data-mp="1gyk1wyt4hvby">
          <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-792" data-mp="1c34o26v47zfj">
            Primary Attorney(s) for Personal Care
          </h3>
          <button type="button" onClick={addPrimaryAttorney} className="flex items-center text-sm text-navy-700 hover:text-navy-900" data-id="element-793" data-mp="3dtg6zwej40f3">
            <PlusIcon size={16} className="mr-1" data-id="element-794" data-mp="7eahcsedbnd2" />
            Add Attorney
          </button>
        </div>

        <div className="bg-blue-50 p-3 rounded-md border border-blue-200 mb-4" data-id="element-795" data-mp="gcmb33aj719q">
          <p className="text-sm text-blue-800" data-id="element-796" data-mp="geyznzaso9vr">
            You may name one or more Primary Attorneys. If you name multiple
            attorneys, you will need to specify whether they should act jointly
            (together) or independently (separately).
          </p>
        </div>

        {primaryAttorneys.map((attorney, index) => <div key={attorney.id} className="p-4 bg-slate-50 rounded-md" data-id="element-797" data-mp="z2u58vw96hds" data-mpi={index}>
            <div className="flex justify-between items-center mb-3" data-id="element-798" data-mp="14271g790l0t1">
              <h4 className="font-medium" data-id="element-799" data-mp="141fbbby6rva5">Primary Attorney {index + 1}</h4>
              {primaryAttorneys.length > 1 && <button type="button" onClick={() => removePrimaryAttorney(attorney.id)} className="text-red-500 hover:text-red-700" data-id="element-800" data-mp="1e0e7vw5og0gs">
                  <TrashIcon size={16} data-id="element-801" data-mp="2tjlvqw0zuynp" />
                </button>}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-802" data-mp="2ojzhqkdcdedu">
              <div data-id="element-803" data-mp="2ombwyprptan7">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-804" data-mp="2jl63gpq8djcm">
                  Name
                  <span className="text-red-500 ml-1" data-id="element-805" data-mp="3h8x00nhjzb6l">*</span>
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter attorney's name" {...register(`healthcarePOA.primary.${index}.name`)} data-id="element-806" data-mp="3hazlcu7rgg4z" />
              </div>
              <div data-id="element-807" data-mp="3ua1q40wjmjk">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-808" data-mp="3us65nxpx72k">
                  Relationship
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="e.g., Spouse, Child, Friend" {...register(`healthcarePOA.primary.${index}.relationship`)} data-id="element-809" data-mp="3v6l9z0a30xwv" />
              </div>
              <div data-id="element-810" data-mp="3asd17zlryutl">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-811" data-mp="3artvdh9efwvx">
                  Phone Number
                </label>
                <input type="tel" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="(123) 456-7890" {...register(`healthcarePOA.primary.${index}.phone`)} data-id="element-812" data-mp="7av5gqja1e9j" />
              </div>
            </div>
            <div className="mt-4" data-id="element-813" data-mp="l92ywoh3txfy">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-814" data-mp="l8t9b1zz1sas">
                Address
              </label>
              <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={2} placeholder="Enter attorney's address" {...register(`healthcarePOA.primary.${index}.address`)} data-id="element-815" data-mp="2ari04bj5oq9z" />
            </div>
          </div>)}

        {/* Joint or Independent - only show if multiple primary attorneys */}
        {primaryAttorneys.length > 1 && <div className="p-4 bg-amber-50 rounded-md border border-amber-200" data-id="element-816" data-mp="1mtstlb3qyqxk">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-817" data-mp="1mvx1s58oic3n">
              Should your primary attorneys act jointly or independently?
            </label>
            <div className="space-y-2" data-id="element-818" data-mp="1wr77b2yad1m6">
              <label className="flex items-start" data-id="element-819" data-mp="1wucuudr9nvfs">
                <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="jointly" {...register('healthcarePOA.primaryActing')} data-id="element-820" data-mp="3c7pf2etoqzbn" />
                <span className="ml-2 block" data-id="element-821" data-mp="24yce240epays">
                  <span className="font-medium" data-id="element-822" data-mp="29ujifsd5meem">Jointly</span>
                  <span className="text-sm text-slate-600 block" data-id="element-823" data-mp="29x5n9k8nuft5">
                    All attorneys must agree and act together on all decisions.
                  </span>
                </span>
              </label>
              <label className="flex items-start" data-id="element-824" data-mp="1m60chjhkudpp">
                <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="independently" {...register('healthcarePOA.primaryActing')} data-id="element-825" data-mp="1m7bfhh377hfr" />
                <span className="ml-2 block" data-id="element-826" data-mp="1zwwqa46ugqcp">
                  <span className="font-medium" data-id="element-827" data-mp="1zypxbklddcl8">
                    Independently (Jointly and Severally)
                  </span>
                  <span className="text-sm text-slate-600 block" data-id="element-828" data-mp="13dfvp0f5jz29">
                    Any one attorney can act alone without the others.
                  </span>
                </span>
              </label>
            </div>
          </div>}
      </div>

      {/* Alternate Attorneys */}
      <div className="space-y-4" data-id="element-829" data-mp="uw5gi3kl2677">
        <div className="flex justify-between items-center" data-id="element-830" data-mp="qw540oh1o52s">
          <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-831" data-mp="qyra0joaeciw">
            Alternate Attorney(s) for Personal Care
          </h3>
          <button type="button" onClick={addAlternateAttorney} className="flex items-center text-sm text-navy-700 hover:text-navy-900" data-id="element-832" data-mp="gzijk0smrg1a">
            <PlusIcon size={16} className="mr-1" data-id="element-833" data-mp="77w1pllseipk" />
            Add Attorney
          </button>
        </div>

        <div className="bg-blue-50 p-3 rounded-md border border-blue-200 mb-4" data-id="element-834" data-mp="37vepckmgz6w">
          <p className="text-sm text-blue-800" data-id="element-835" data-mp="3udwqxogbpyu4">
            Alternate attorneys will act if your primary attorney(s) are unable
            or unwilling to act. You may name one or more alternates.
          </p>
        </div>

        {alternateAttorneys.map((attorney, index) => <div key={attorney.id} className="p-4 bg-slate-50 rounded-md" data-id="element-836" data-mp="1m4ovxb6bjvau" data-mpi={index}>
            <div className="flex justify-between items-center mb-3" data-id="element-837" data-mp="1m2kwb5fgdigd">
              <h4 className="font-medium" data-id="element-838" data-mp="1844dwh88a3ie">Alternate Attorney {index + 1}</h4>
              {alternateAttorneys.length > 1 && <button type="button" onClick={() => removeAlternateAttorney(attorney.id)} className="text-red-500 hover:text-red-700" data-id="element-839" data-mp="1d63itvjm98hg">
                  <TrashIcon size={16} data-id="element-840" data-mp="137nqxqcrlv6w" />
                </button>}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-841" data-mp="pcbo0voggyew">
              <div data-id="element-842" data-mp="tgt0saweebg6">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-843" data-mp="tdx5kubxq0vf">
                  Name
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter alternate attorney's name" {...register(`healthcarePOA.alternate.${index}.name`)} data-id="element-844" data-mp="kfbqj95o93ze" />
              </div>
              <div data-id="element-845" data-mp="ataitv7h3boa">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-846" data-mp="apmoitu7el8i">
                  Relationship
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="e.g., Sibling, Friend" {...register(`healthcarePOA.alternate.${index}.relationship`)} data-id="element-847" data-mp="js4cbcpiblxm" />
              </div>
              <div data-id="element-848" data-mp="ojw23l0u9nmp">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-849" data-mp="olgognd0209h">
                  Phone Number
                </label>
                <input type="tel" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="(123) 456-7890" {...register(`healthcarePOA.alternate.${index}.phone`)} data-id="element-850" data-mp="yhtpk6avjge9" />
              </div>
            </div>
            <div className="mt-4" data-id="element-851" data-mp="dllwbbit67mi">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-852" data-mp="8p3rkbnha9a6">
                Address
              </label>
              <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={2} placeholder="Enter alternate attorney's address" {...register(`healthcarePOA.alternate.${index}.address`)} data-id="element-853" data-mp="16baw5ljs81mj" />
            </div>
          </div>)}

        {/* Joint or Independent for alternates - only show if multiple alternate attorneys */}
        {alternateAttorneys.length > 1 && <div className="p-4 bg-amber-50 rounded-md border border-amber-200" data-id="element-854" data-mp="3d18qrg3dlass">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-855" data-mp="1slsq39hc2vhv">
              Should your alternate attorneys act jointly or independently?
            </label>
            <div className="space-y-2" data-id="element-856" data-mp="21lpldty8aslw">
              <label className="flex items-start" data-id="element-857" data-mp="21knxuq010dna">
                <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="jointly" {...register('healthcarePOA.alternateActing')} data-id="element-858" data-mp="26c5zlg9vii9b" />
                <span className="ml-2 block" data-id="element-859" data-mp="2g9aklcrzg7oj">
                  <span className="font-medium" data-id="element-860" data-mp="2gc6mtdav5iis">Jointly</span>
                  <span className="text-sm text-slate-600 block" data-id="element-861" data-mp="2kd8k3ol7zki4">
                    All attorneys must agree and act together on all decisions.
                  </span>
                </span>
              </label>
              <label className="flex items-start" data-id="element-862" data-mp="pzquzx562fkz">
                <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="independently" {...register('healthcarePOA.alternateActing')} data-id="element-863" data-mp="uwhbumospf7g" />
                <span className="ml-2 block" data-id="element-864" data-mp="1tao71yit0lhs">
                  <span className="font-medium" data-id="element-865" data-mp="2794exsseki1i">
                    Independently (Jointly and Severally)
                  </span>
                  <span className="text-sm text-slate-600 block" data-id="element-866" data-mp="228qjda7zn0kd">
                    Any one attorney can act alone without the others.
                  </span>
                </span>
              </label>
            </div>
          </div>}
      </div>
    </div>;
};
export default HealthcarePOA;